import { FC, useContext, useRef } from 'react';
import classnames from 'classnames';

import { StickyTableHeader } from '@hh.ru/magritte-ui-table/StickyTableHeader';
import { TableContext } from '@hh.ru/magritte-ui-table/context';
import { TableHeaderProps } from '@hh.ru/magritte-ui-table/types';

import styles from './table.less';

const DENSITY_TO_CSS = {
    'extra-small': styles.densityExtraSmall,
    small: styles.densitySmall,
    medium: styles.densityMedium,
    large: styles.densityLarge,
};

export const TableHeader: FC<TableHeaderProps> = ({
    divider,
    density = 'small',
    'data-qa': dataQa = 'table-header',
    children,
}) => {
    const theadRef = useRef<HTMLTableSectionElement>(null);
    const tableContext = useContext(TableContext);
    const withDivider = divider ?? tableContext.divider;

    return (
        <>
            <thead
                ref={theadRef}
                className={classnames(styles.header, DENSITY_TO_CSS[density], {
                    [styles.withDivider]: !!withDivider,
                })}
                data-qa={dataQa}
            >
                {children}
            </thead>
            {tableContext.stickyHeader && tableContext.headerNode && (
                <StickyTableHeader
                    root={tableContext.headerNode}
                    headerRef={theadRef}
                    divider={withDivider}
                    density={density}
                >
                    {children}
                </StickyTableHeader>
            )}
        </>
    );
};
